import { style } from '@vtex/admin-ui'

export const skuOffersWrapper = style({
  '&:not(:first-child)': {
    borderTop: '$neutral',
    marginTop: '0 !important',
  },
})

export const cardHeader = style({
  width: '100%',
  padding: '$space-3 $space-6',
  bg: '$action.neutral.tertiary',
  fg: '$action.neutral.tertiary',
  transition: 'all 0.1s linear',
  ':hover': {
    bg: '$action.neutral.tertiaryHover',
    fg: '$action.neutral.tertiaryHover',
  },
  ':active': {
    bg: '$action.neutral.tertiaryPressed',
    fg: '$action.neutral.tertiaryPressed',
  },
  cursor: 'pointer',
  div: {
    display: 'flex',
    alignItems: 'center',
  },
})

export const tableBody = {
  div: {
    justifyContent: 'center',
  },
  tr: {
    '&:last-child': {
      td: { borderBottom: 'none' },
    },
  },
}
